// extracted by mini-css-extract-plugin
module.exports = {"goBack":"goal_goBack__28bN8","statsTitle":"goal_statsTitle__K2V0W","statsBody":"goal_statsBody__38lO7","statsContent":"goal_statsContent__1vEsG"};